import { Button, ButtonProps, CircularProgress } from "@mui/material";

interface Props extends ButtonProps {
  loading?: boolean;
  loadingText?: React.ReactNode;
}

export const ButtonLoading = (props: Props) => {
  const { loading, loadingText, startIcon, disabled, children, ...buttonProps } =
    props;

  const isLoading = Boolean(loading);
  const finalDisabled = disabled || isLoading;

  return (
    <Button
      {...buttonProps}
      disabled={finalDisabled}
      startIcon={
        isLoading ? (
          <CircularProgress color="inherit" size={16} />
        ) : (
          startIcon
        )
      }
    >
      {isLoading && loadingText !== undefined ? loadingText : children}
    </Button>
  );
};
